var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-x align-middle"},[_c('div',{staticClass:"cell shrink"},[_c('span',{staticStyle:{"padding-right":".3rem"},domProps:{"innerHTML":_vm._s(_vm.$icons.get('sync', 'large spin'))}})]),_c('div',{staticClass:"cell auto"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }